import React from 'react';

import type { IdUserDto } from '@/services/ws-companies/src/main/resources/rest-api';
import { getCreatedByUsers } from '@/services/ws-orders/src/main/resources/rest-api';
import { useSubscribe } from '@/js/libs/observable';
import { useRequest } from '@/js/libs/use-request';

import type { Option } from 'src/types';

type UseCreatedByUsersOptionsReturn = {
  options: Option<IdUserDto>[];
  pending: boolean;
};

type UseCreatedByUsersOptions = () => UseCreatedByUsersOptionsReturn;

export const useCreatedByUsersOptions: UseCreatedByUsersOptions = () => {
  const getCreatedByUsersRequest = useRequest({
    apiMethod: getCreatedByUsers,
    params: { type: 'CAMPAIGN' },
  });

  const options = useSubscribe(
    getCreatedByUsersRequest.data$,
    (response) =>
      response?.data.map((item) => ({
        label: item.name ?? `${item.firstName} ${item.lastName}`,
        value: item.id,
      })) ?? [],
  );
  const pending = useSubscribe(getCreatedByUsersRequest.pending$);

  return React.useMemo<UseCreatedByUsersOptionsReturn>(
    () => ({
      options,
      pending,
    }),
    [options, pending],
  );
};
